import { createFileRoute, notFound, useRouter } from '@tanstack/react-router'

import { GridItem } from '@masterplandev/ui'

import { ContainerFullViewport } from '@/core/components/ui/ContainerFullViewport/ContainerFullViewport'
import { FEATURE_DASHBOARD_EXCLUSIVE_CHANNEL } from '@/core/constants/features'
import { TopicSection } from '@/topic/components/TopicSection/TopicSection'

export const Route = createFileRoute(
  '/_learning/_company/exclusive-content/view/$topic',
)({
  beforeLoad: ({ context }) => {
    if (!context.user?.features.includes(FEATURE_DASHBOARD_EXCLUSIVE_CHANNEL)) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { topic: topicSlug } = Route.useParams()
  const router = useRouter()
  const returnUrl = router.buildLocation({ to: '/exclusive-content' }).href

  return (
    <GridItem gridColumn="1 / -1">
      <ContainerFullViewport left="50%" transform="translateX(-50%)">
        <TopicSection
          lectureContext="channel"
          returnUrl={returnUrl}
          topicSlug={topicSlug}
        />
      </ContainerFullViewport>
    </GridItem>
  )
}
